import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_AUFGABE_BILD_ENTFERNEN = '[VeranstaltungenModul] PostAufgabeBildEntfernen laden';
export const POST_AUFGABE_BILD_ENTFERNEN_AUSFUEHREN = '[VeranstaltungenModul] PostAufgabeBildEntfernen ausführen';
export const POST_AUFGABE_BILD_ENTFERNEN_ERFOLGREICH = '[VeranstaltungenModul] PostAufgabeBildEntfernen laden erfolgreich';
export const POST_AUFGABE_BILD_ENTFERNEN_FEHLER = '[VeranstaltungenModul] PostAufgabeBildEntfernen Ladefehler';
export const POST_AUFGABE_BILD_ENTFERNEN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostAufgabeBildEntfernen nicht ausgeführt (evtl. Offline)';


export class PostAufgabeBildEntfernenAction implements Action {
    readonly type = POST_AUFGABE_BILD_ENTFERNEN;
        constructor(public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeBildEntfernenAusfuehrenAction implements Action {
    readonly type = POST_AUFGABE_BILD_ENTFERNEN_AUSFUEHREN;
        constructor(public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeBildEntfernenErfolgreichAction implements Action {
    readonly type = POST_AUFGABE_BILD_ENTFERNEN_ERFOLGREICH;
        constructor(public payload: api.AufgabeIdentifier, public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeBildEntfernenFehlerAction implements Action {
    readonly type = POST_AUFGABE_BILD_ENTFERNEN_FEHLER;
        constructor(public payload: any, public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeBildEntfernenNichtAusgefuehrtAction implements Action {
    readonly type = POST_AUFGABE_BILD_ENTFERNEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandAufgabeBildEntfernenActions =
    PostAufgabeBildEntfernenAction
    | PostAufgabeBildEntfernenAusfuehrenAction
    | PostAufgabeBildEntfernenErfolgreichAction
    | PostAufgabeBildEntfernenFehlerAction
    | PostAufgabeBildEntfernenNichtAusgefuehrtAction
    ;
